var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagePending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-5{fill:none;stroke:var(--gray-icon);stroke-miterlimit:10;stroke-width:3px;}.message-pendingg{fill:#e799af}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7",
    x1: 32.02,
    y1: 8.32,
    x2: 48,
    y2: 8.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40cbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325aa6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.26,4.31C11.52,4.31,2,12.41,2,22.41,2,28,5,33,9.7,36.35l-.85,7.32,9.75-3.61a25.39,25.39,0,0,0,4.66.45c11.74,0,21.26-8.11,21.26-18.1S35,4.31,23.26,4.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "message-pendingg",
    d: "M48,8.32a8,8,0,1,1-8-8A8,8,0,0,1,48,8.32Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePending);
export default __webpack_public_path__ + "static/media/messagePending.e223b126086ea9d20fd7fea29e9b14aa.svg";
export { ForwardRef as ReactComponent };